import { INCREMENT_POST_LIKE_COUNT_SUCCESS } from '../../actions/increment-post-like-count';
import { INCREMENT_COMMENT_LIKE_COUNT_SUCCESS } from '../../actions/increment-comment-like-count';

const handler = ({ payload, type }) => {
  const { _id, isLiked } = payload;

  let postId = _id;
  let commentId = null;

  if (type === INCREMENT_COMMENT_LIKE_COUNT_SUCCESS) {
    commentId = _id;
    postId = payload.postId;
  }

  return {
    evid: 209,
    comment_id: commentId,
    flag: isLiked,
    is_published: true,
    post_id: postId,
    eventMeta: {
      description: 'post or comment like clicked',
    },
  };
};

export const uouLikeClickEvent = {
  [INCREMENT_POST_LIKE_COUNT_SUCCESS]: handler,
  [INCREMENT_COMMENT_LIKE_COUNT_SUCCESS]: handler,
};
